export const InputFieldSkeleton = ({ label, htmlFor }: { label: string; htmlFor: string }) => (
  <div>
    <div className='flex flex-row items-center mb-2'>
      <label className='text-primary text-body-xs' htmlFor={htmlFor}>
        {label}
      </label>
    </div>
    <div className='flex flex-col'>
      <div className='relative flex items-center w-full'>
        <div className='w-full h-12 bg-tertiary rounded-sm animate-pulse' />
      </div>
    </div>
  </div>
);
